import GenericRequest, { METHOD_POST } from '../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../shared/webservices/endpoint';

export default class MachinesRequest extends GenericRequest {

    term;
    page;
    filter;
    company_id;
    show_only_deleted;
    include_only_contractor_machines;
    include_only_company_machines;
    retrieve_machine_documentation_state;

    constructor(
        page,
        term = '',
        filter = 0,
        company_id = null,
        show_only_deleted = false,
        include_only_contractor_machines = false,
        include_only_company_machines = false,
        retrieve_machine_documentation_state = true,
    ) {
        super(METHOD_POST, ApiEndpoints.MACHINES);

        this.page = page;
        this.term = term;
        this.filter = filter;
        this.company_id = company_id;
        this.show_only_deleted = show_only_deleted;
        this.include_only_contractor_machines = include_only_contractor_machines;
        this.include_only_company_machines = include_only_company_machines;
        this.retrieve_machine_documentation_state = retrieve_machine_documentation_state;
    }

    overrideRequest() {
        const request = {};
        request.criteria = {};
        if ( this.page ) request.criteria.page = this.page;
        if ( this.term ) request.criteria.term = this.term;
        if ( this.filter && this.filter !== 0 ) request.criteria.machine_state_ids = [this.filter];
        if ( this.company_id ) request.criteria.company_id = this.company_id;
        if ( this.include_only_contractor_machines ) request.criteria.include_only_contractor_machines = this.include_only_contractor_machines;
        if ( this.include_only_company_machines ) request.criteria.include_only_company_machines = this.include_only_company_machines;
        if ( this.retrieve_machine_documentation_state ) request.criteria.retrieve_machine_documentation_state = this.retrieve_machine_documentation_state;
        request.criteria.show_only_deleted = this.show_only_deleted;
        request.criteria.skip_companies_inactive = true;
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/machines/ws/MachinesRequest.js